import { Reducer } from "redux";
import { produce } from "immer";

import { PROJECT_PROGRESS_SUMMARY_LOADED, ProjectProgressSummaryLoadedEvent } from "../../../events/loaded/projects/project_progress_summary_loaded";

import type { ApiProjectProgressSummary } from "avvir";

export type ProjectProgressSummariesStore = {
  byFirebaseProjectId: { [projectId: string]: ApiProjectProgressSummary }
}

const reduceProjectProgressSummaries: Reducer<ProjectProgressSummariesStore, ProjectProgressSummaryLoadedEvent> = (
  summaries: ProjectProgressSummariesStore = { byFirebaseProjectId: {} },
  event
) => {
  return produce<ProjectProgressSummariesStore>(summaries, (draft) => {
    if (!draft.byFirebaseProjectId) {
      draft.byFirebaseProjectId = {};
    }
    switch (event.type) {
      case PROJECT_PROGRESS_SUMMARY_LOADED: {
        draft.byFirebaseProjectId[event.payload.projectId] = event.payload.summary;
        return draft;
      }
      default: {
        return draft;
      }
    }
  });
};

export default reduceProjectProgressSummaries;
